import useLocale from '@/utils/useLocale'
import { Space } from '@arco-design/web-react'
import { IconLeft, IconWechat } from '@arco-design/web-react/icon'
import IconGoogle from '@/assets/google.svg'
import { useEffect, useState } from 'react'
import { Spin } from '@arco-design/web-react'
import LoginBtn from '../login/login-btn'
import WeChatLogin from '../login/wechat-login'
import LoginForm from './form'
import styles from './style/register-en.module.less'
import { useRouter } from 'next/router'
import { BindAuthRes } from '@/types/api'
import { setToken } from '@/utils/checkLogin'
import useGoogleAuth from '@/hooks/useGoogleAuth'
import { INVITE_CODE_STORAGE } from '@/utils/constants'
import { useGetQuery } from '@/hooks/useGetQuery'
import PhoneForm from '../login/phone-form'
import useLang from '@/utils/useLang'

function RegisterContent() {
  const router = useRouter()
  const { query } = router
  const { step: initStep = '', platform = '', sessionFlag: initSessionFlag = '', f = '' } = query || {}
  const email = useGetQuery('email')

  const [inviteCode, setInviteCode] = useState('')
  const [sessionFlag, setSessionFlag] = useState<string>(initSessionFlag as string)
  const [showWechat, setShowWechat] = useState(false)
  const lang = useLang()
  const isEnglish = lang === 'en-US'
  const [componentType, setComponentType] = useState<'email' | 'phone'>(isEnglish ? 'email' : 'phone')

  const t = useLocale()

  useEffect(() => {
    const curInviteCode = f || localStorage.getItem(INVITE_CODE_STORAGE) || ''
    setInviteCode(curInviteCode as string)
  }, [f])

  const onBindSuccess = (data: BindAuthRes) => {
    setToken(data?.access_token)
    if (!data?.user?.role) {
      window.location.href = window.location.origin + '/onboarding'
    } else {
      window.location.href = window.location.origin + '/board'
    }
  }

  useEffect(() => {
    if (lang === 'en-US') {
      setComponentType('email')
    }
  }, [lang])

  const { googleAuth, isLoading } = useGoogleAuth({
    onBindSuccess,
    invite_code: inviteCode
  })

  return (
    <div className={styles.container}>
      <div className={styles['login-form-title']}>{t['register.form.title']}</div>
      <>
        {showWechat ? (
          <>
            <div
              style={{ color: '#403D5A', lineHeight: '19px', marginBottom: '32px', cursor: 'pointer' }}
              onClick={() => {
                setShowWechat(false)
              }}
            >
              <IconLeft style={{ marginRight: '8px', width: '18px' }} />
              {t['register.another.way']}
            </div>
            <WeChatLogin
              key="register"
              type="register"
              step=""
              sessionFlag={sessionFlag}
              setSessionFlag={setSessionFlag}
              inviteCode={inviteCode}
            />
          </>
        ) : (
          <Spin loading={isLoading}>
            <Space direction="vertical" size={16} style={{ width: '100%', marginTop: '24px' }}>
              <LoginBtn
                key="google"
                icon={<IconGoogle />}
                text={t['register.google']}
                onClick={() => {
                  try {
                    window.gtag_report_conversion?.()
                  } catch (error) {
                    console.log(error)
                  }
                  googleAuth()
                }}
              />
              <LoginBtn
                key="wechat"
                icon={<IconWechat style={{ color: '#00C800', width: '24px', height: '24px' }} />}
                text={t['register.wechat']}
                onClick={() => {
                  // try {
                  //   window.gtag_report_conversion?.()
                  // } catch (error) {
                  //   console.log(error)
                  // }
                  setShowWechat(true)
                }}
              />
            </Space>

            <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
              <div style={{ height: '1px', flex: 1, backgroundColor: '#F0F1F8' }}></div>
              <div style={{ margin: '0 8px', color: '#403D5A' }}>{t['register.or']}</div>
              <div style={{ height: '1px', flex: 1, backgroundColor: '#F0F1F8' }}></div>
            </div>
            {componentType === 'email' ? (
              <LoginForm
                email={email}
                sessionFlag={sessionFlag}
                inviteCode={inviteCode}
                step="fulfill"
                platform={platform}
                onChangeForm={(v) => {
                  setComponentType(v)
                }}
              />
            ) : (
              <PhoneForm
                inviteCode={inviteCode}
                onChangeForm={(v) => {
                  setComponentType(v)
                }}
              />
            )}
          </Spin>
        )}
      </>
    </div>
  )
}

export default RegisterContent
